import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CommunityStoreActions,
  CommunityStoreSelectors,
  CommunityStoreReducer,
} from './index';
import { CommunityDto } from '@cradua/data';

@Injectable()
export class CommunityFacade {
  constructor(
    private store: Store<CommunityStoreReducer.CommunityPartialState>
  ) {}

  communityRecord$ = this.store.select(CommunityStoreSelectors.getSelected);
  communityRecordError$ = this.store.select(
    CommunityStoreSelectors.getCommunityError
  );

  getselected() {
    return this.store.select(CommunityStoreSelectors.getSelected);
  }

  get isLoadingCommunity() {
    this.store.dispatch(CommunityStoreActions.loadCommunity());
    return this.store.select(CommunityStoreSelectors.loadingCommunity);
  }

  get loadCommunity() {
    this.store.dispatch(CommunityStoreActions.loadCommunity());
    return this.store.select(CommunityStoreSelectors.getAllCommunity);
  }

  addCommunity(newCommunity: CommunityDto[]) {
    this.store.dispatch(CommunityStoreActions.addCommunity({ newCommunity }));
  }

  updateCommunity(updateCommunity: CommunityDto[]) {
    this.store.dispatch(
      CommunityStoreActions.updateCommunity({ updateCommunity })
    );
  }

  removeCommunity(ids: string[]) {
    this.store.dispatch(CommunityStoreActions.removeCommunity({ ids }));
  }
}
